export enum Filters {
  Team = 'teamId',
  Type = 'typeId',
  TagKey = 'tagKey',
  TagValue = 'tagValue',
}
